import {
  AddShoppingCartRounded,
  Build,
  Paid,
  Score,
  ShoppingBasketRounded,
  TrendingUp,
} from "@mui/icons-material";
import Stack from "@mui/material/Stack";
import { Paper } from "../../../components/Paper";
import { useStyles } from "../styles";
import { Bar } from "../../../components/Recharts/Bar";
import { Pie } from "../../../components/Recharts/Pie";
import WithoutInformation from "../../Home/WithoutInformation";
import { isEmpty } from "lodash";
import { PaperChart } from "../../../components/PaperChart";
import { OverviewOffer } from "../../../types/offers";

type dataOverviewProps = {
  loading: boolean;
  overview: OverviewOffer;
  genre: any[];
  ageGroup: any[];
  day: any[];
  store: any[];
  hours: any[];
};

export function Overview({
  loading,
  overview,
  genre,
  ageGroup,
  day,
  hours,
  store,
}: dataOverviewProps) {
  const styles = useStyles();

  return (
    <>
      <Stack spacing={4}>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Paper
            loading={loading}
            icon={<ShoppingBasketRounded color="primary" fontSize="large" />}
            label="Ticket médio"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(overview?.ticket_medio)}
            prefix="R$"
            decimals={2}
          />
          <Paper
            loading={loading}
            icon={<Build color="primary" fontSize="large" />}
            label="Investimento"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(overview?.investimento)}
          />
          <Paper
            loading={loading}
            icon={<Score color="primary" fontSize="large" />}
            label="Vendas"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(overview?.qtde_vendas)}
          />

          <Paper
            loading={loading}
            icon={<AddShoppingCartRounded color="primary" fontSize="large" />}
            label="Faturamento"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(overview?.faturamento)}
            prefix="R$"
            decimals={2}
          />

          <Paper
            loading={loading}
            icon={<Paid color="primary" fontSize="large" />}
            label="ROI"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(overview?.roi)}
            prefix="R$"
            decimals={2}
          />

          <Paper
            loading={loading}
            icon={<TrendingUp color="primary" fontSize="large" />}
            label="Margem"
            className={styles.paper}
            variant="outlined"
            elevation={0}
            end={Number(overview?.margem_percentual)}
            suffix="%"
            decimals={2}
          />
        </Stack>

        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <PaperChart
            loading={loading}
            label="Vendas por lojas"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(store) ? (
              //@ts-ignore
              <Bar
                barLegend
                xDataKey="nome_loja"
                barDataKey="qtde_vendas"
                data={store}
              />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>

          <PaperChart
            loading={loading}
            label="Vendas por dias"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(day) ? (
              //@ts-ignore
              <Bar
                barLegend
                xDataKey="DATA_ANALISE"
                barDataKey="qtde_vendas"
                data={day}
              />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>
        </Stack>
        <PaperChart
          loading={loading}
          label="Vendas por horas"
          className={styles.paperCreatedDay}
          variant="outlined"
          elevation={0}
        >
          {!isEmpty(hours) ? (
            //@ts-ignore
            <Bar
              barLegend
              xDataKey="HORA_ANALISE"
              barDataKey="qtde_vendas"
              data={hours}
            />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>

        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <PaperChart
            loading={loading}
            label="Gênero"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(genre) ? (
              <Pie nameKey="name" dataKey="value" data={genre} />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>

          <PaperChart
            loading={loading}
            label="Faixa etária"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(ageGroup) ? (
              <Pie nameKey="name" dataKey="value" data={ageGroup} />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>
        </Stack>
      </Stack>
    </>
  );
}
